import { Container } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import {
  deleteHealth,
  getHealth,
  restoreHealth,
  updateHealth,
} from "../../../api";
import EditNewsForm from "../../EditNewsForm";

export default function EditHealth() {
  const location = useLocation();
  const navigate = useNavigate();

  const customSubmitFunction = async (id, title, description, image) => {
    try {
      const result = await updateHealth(id, title, description, image);
      if (result) {
        navigate("/health/all");
      }
    } catch (error) {}
  };

  const publishHealth = async (id) => {
    try {
      await restoreHealth(id);

      navigate("/health/all");
    } catch (error) {}
  };
  const unPublishHealth = async (id) => {
    try {
      await deleteHealth(id);

      navigate("/health/all");
    } catch (error) {
      throw error;
    }
  };

  const getOneHealth = async (id) => {
    try {
      const result = await getHealth(id);
      return result;
    } catch (error) {
      throw error;
    }
  };

  return (
    <>
      <Container>
        <EditNewsForm
          ItemId={location?.state?.healthId}
          breadCrumbLink={"Health"}
          breadCrumbText={"Edit Health"}
          goBackLink={"/health/all"}
          customsubmit={customSubmitFunction}
          publishItem={publishHealth}
          unPublishItem={unPublishHealth}
          getOneItem={getOneHealth}
        />
      </Container>
    </>
  );
}
